export class Populations {
  public static Default = 'Default';
  public static Kids = 'Kids';
}
